import { declense } from '../../../../../libs/declense';
import { Site } from '../../../../../types';
import { useMemo } from 'react';
import { area } from '@turf/turf';

type Attributes = { key: string; value: string; note?: string }[];

const useAcreage = (site: Site) => {
  return useMemo(() => {
    if (!site.boundary) {
      return 0;
    }

    const areaSqMeters = area(site.boundary);
    return areaSqMeters / 4046.8564224;
  }, [site.boundary]);
};

export const useMissionAttributes = (site: Site) => {
  const { projectInfo } = site;

  const acreage = useAcreage(site);

  const srsAttributes = Object.entries({
    'Horizontal CRS': projectInfo.horizontalCrs,
    'Vertical CRS': projectInfo.verticalCrs,
  }).reduce((acc, [key, value]) => {
    if (value) {
      acc.push({ key, value });
    }
    return acc;
  }, [] as Attributes);

  const otherAttributes = Object.entries({
    'Target Flight Altitude': projectInfo.expectedFlightAltitude ? `${projectInfo.expectedFlightAltitude}ft AGL` : null,
    Acreage: acreage > 0 ? declense(+acreage.toFixed(2), 'acre', 'acres') : null,
    'Site Access': projectInfo.siteAccess,
  }).reduce((acc, [key, value]) => {
    if (value) {
      acc.push({ key, value });
    }
    return acc;
  }, [] as Attributes);

  return { srsAttributes, otherAttributes };
};
